__turbopack_context__.v({
  "action": "T6G1Kq_action",
  "container": "T6G1Kq_container",
  "copy": "T6G1Kq_copy",
  "divider": "T6G1Kq_divider",
  "eyebrow": "T6G1Kq_eyebrow",
  "message": "T6G1Kq_message",
  "sendAnother": "T6G1Kq_sendAnother",
  "title": "T6G1Kq_title",
});
